<template>
  <div class="productDetails">
    <!-- <transition name="moveInUp">
      <router-view />
    </transition>-->
    <div class="component-padding">
      <div v-for="(product,index) in products" :key="index">
        <div class="row" v-if="prodId == product.productId">
          <div class="col-12 col-md-5">
            <carousel :per-page="1" autoplay>
              <slide v-for="(data,index) in product.sliderImages" :key="index">
                <img
                  :src="require('@/assets/images/' + data)"
                  :alt="data"
                  class="product_details-image"
                />
              </slide>
            </carousel>
          </div>
          <div class="col-12 col-md-7">
            <h1 class="product_details-text product_details-text-lg">{{product.productTitle}}</h1>
            <div class="border_line product_details-mt product_details-mb"></div>
            <h3 class="product_details-text product_details-text-lg">ფასი: {{product.price}}</h3>
            <h3
              class="product_details-text product_details-text-bold product_details-mt"
            >პროდუქტის აღწერა:</h3>
            <div class="border_line product_details-mb"></div>
            <p class="product_details-text">{{product.description}}</p>
            <a
              class="buy_btn"
              href="http://m.me/Skinlove.ge"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="buy_btn-title-cont">
                <span class="buy_btn-title">შესაძენად მოგვწერეთ:</span>
                <span class="fab fa-facebook-messenger messenger-icon"></span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productsJson from "@/json/db.json";

export default {
  name: "productDetails",
  data() {
    return {
      title: "productDetails",
      prodId: this.$route.params.Pid
    };
  },
  computed: {
    products() {
      return productsJson.products.map(item => {
        return item;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/global";

.buy_btn {
  border: 1px solid $skyblueLight;
  background-color: transparent;
  color: $skyblueLight;
  padding: 2vh 3vh;
  text-decoration: none;
  transition: 0.5s;
  font-family: $fontALKSanet;
  font-size: $font-sm;
  letter-spacing: 0.1vh;
  display: inline-block;
  margin: 2vh 0;
  border-radius: 2vh;
  &:hover,
  &:focus {
    box-shadow: inset 50em 0 0 0 $skyblueLight;
    color: black;
    & .messenger-icon {
      color: black;
    }
  }
}

.product_details {
  &-image {
    width: 100%;
    height: 50vh;
    object-fit: cover;
  }
  &-text {
    color: $skyblueLight;
    font-size: $font-sm;
    font-family: $fontALKSanet;
    &-lg {
      font-size: $font-md;
    }
    &-bold {
      font-weight: bold;
    }
  }
  &-mt {
    margin-top: 3vh;
  }
  &-mb {
    margin-bottom: 3vh;
  }
}
.border_line {
  width: 50%;
  height: 2px;
  background: $grey;
}
.messenger-icon {
  color: $skyblueLight;
  text-decoration: none;
  font-size: $font-md;
  position: relative;
  z-index: 1;
  transition: 0.5s;
  margin-left: 0.5vh;
}
@media screen and (min-width: 992px) {
  .product_details {
    &-image {
      height: 95vh;
    }
    &-text {
      font-size: $font-md;
      font-size: $font-md;
      &-lg {
        font-size: $font-lg;
      }
    }
    &-mt {
      margin-top: 5vh;
    }
    &-mb {
      margin-bottom: 5vh;
    }
  }
  .buy_btn {
    transition: 1s;
    letter-spacing: 0.4vh;
    &-title {
      font-size: $font-lg;
    }
  }
  .messenger-icon {
    font-size: $font-xl;
    margin-left: 2vh;
    transition: 1s;
  }
}
</style>